<template>
  <b-table
    :data="data"
    :loading="isLoading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column label="#" numeric>{{ props.row.id }}</b-table-column>

      <b-table-column label="Data e Hora">
        {{ props.row.datetime | date('DD/MM/YYYY [às] HH:mm') }}
      </b-table-column>

      <b-table-column label="Orígem">{{ props.row.origin }}</b-table-column>

      <b-table-column label="Rede">{{ props.row.network }}</b-table-column>

      <b-table-column label="Status">{{ props.row.status }}</b-table-column>

      <b-table-column label="Opções">
        <router-link
          :to="`${props.row.id}/show`"
          tag="button"
          type="button"
          v-tooltip.bottom="'Visualizar'"
          v-app-button.icon-only
        >
          <b-icon size="is-small" icon="magnify"></b-icon>
        </router-link>
        <button
          @click="onClickDeleteImport(props.row.id)"
          v-app-button.icon-only
          color="danger"
          v-tooltip.bottom="'Excluir'"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import ImportService from '@/services/import.service';

export default {
  name: 'imports-table',
  data: () => {
    return {
      data: [],
      total: 0,
      isLoading: true,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      ImportService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Cargas.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onClickDeleteImport(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Carga',
        message:
          'Tem certeza que deseja solicitar a <b>exclusão</b> desta carga? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Carga',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteImport(id),
      });
    },
    deleteImport(id) {
      this.isLoading = true;

      ImportService.delete(id)
        .then(() => {
          this.toastify(
            'Solicitação de exclusão realizada com sucesso. A carga será excluída em instantes.'
          );
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Carga.',
            'error'
          );
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
